// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"o9-z"};